import { AppPathNames } from "@/constants/AppPathNames";
import { slices } from "@/constants/sliceNames";
import { Spin } from "antd";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

export default function WithoutAuthGuard({ children }) {
  const { loading, userToken } = useSelector((state) => state[slices.auth]);
  const navigate = useNavigate();
  const location = useLocation();
  const { from } = location.state || { from: { pathname: `${AppPathNames.dashboard}` } };

  const isAuthenticated = !!userToken;

  const [isPathValid] = useMemo(() => {
    return Object.values(AppPathNames).filter((path) => path.split("/")[1] === from.pathname.split("/")[1]);
  }, [from.pathname]);

  React.useEffect(() => {
    if (isAuthenticated) {
      userToken && isPathValid && navigate(from.pathname);
      userToken && !isPathValid && navigate(AppPathNames.dashboard);
    }
  }, [from.pathname, isAuthenticated, isPathValid, navigate, userToken]);

  return <>{loading ? <Spin spinning={loading}>{children}</Spin> : !isAuthenticated && children}</>;
}
